<template>
  <v-app id="app">
    <qb-stacked-snackbar />
    <web3-modal-vue
        ref="Web3ModalComponent"
        :theme="web3ModalTheme"
        :provider-options="web3ModalProviderOptions"
        cache-provider
    />
    <router-view />
  </v-app>
</template>

<script>
import './styles/main.scss'
import Web3ModalVue from 'web3modal-vue'
import QbStackedSnackbar from '@/components/general/QbStackedSnackbar.vue'
import WalletConnectProvider from '@walletconnect/web3-provider'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: {
    Web3ModalVue,
    QbStackedSnackbar
  },
  data () {
    return {
      web3ModalTheme: 'dark',
      web3ModalProviderOptions: {
        walletconnect: {
          package: WalletConnectProvider,
          options: {
            infuraId: '-'
          }
        }
      }
    }
  },
  computed: {
    ...mapState(['web3Modal'])
  },
  active () {
    return this.web3Modal.active
  },
  methods: {
    printSelfXSSWarning () {
      console.log(' ') // eslint-disable-line no-console
      console.log(' ') // eslint-disable-line no-console
      console.log('%c   STOP!!!  ', 'background: ' + this.$vuetify.theme.themes.dark.accent + '; color: white; font-size: 48px') // eslint-disable-line no-console
      console.log('%c This browser feature is for developers only. ', 'background: black; color: ' + this.$vuetify.theme.themes.dark.primary + '; font-size: 24px') // eslint-disable-line no-console
      console.log('%c Please refrain from pasting code or running scripts here. ', 'background: black; color: ' + this.$vuetify.theme.themes.dark.primary + '; font-size: 24px') // eslint-disable-line no-console
      console.log('%c It may cause your wallet account, your tokens and/or your private data to be compromised. ', 'background: black; color: ' + this.$vuetify.theme.themes.dark.primary + '; font-size: 24px') // eslint-disable-line no-console
      console.log(' ') // eslint-disable-line no-console
      console.log('%c Please find additional information at ', 'background: black; color: ' + this.$vuetify.theme.themes.dark.secondary + '; font-weight: 500; font-size: 14px') // eslint-disable-line no-console
      console.log('%c http://en.wikipedia.org/wiki/Self-XSS ', 'background: black; color: ' + this.$vuetify.theme.themes.dark.secondary + '; font-weight: 700; font-style: italic; font-size: 16px') // eslint-disable-line no-console
      console.log(' ') // eslint-disable-line no-console
      console.log(' ') // eslint-disable-line no-console
    }
  },
  created () {
    this.printSelfXSSWarning()
  },
  mounted () {
    this.$nextTick(() => {
      const web3Modal = this.$refs.Web3ModalComponent
      this.$store.dispatch('web3InitModal', web3Modal)
        .then(() => {
          if (web3Modal.cachedProvider) {
            this.$store.dispatch('web3Connect')
          }
        })
    })

    this.$root.$on('copy-text', (textToCopy, parentElement = document.body) => {
      const copyTextElement = document.createElement('textarea')
      copyTextElement.value = textToCopy
      parentElement.appendChild(copyTextElement)
      copyTextElement.select()
      copyTextElement.setSelectionRange(0, 99999) /* For mobile devices */
      document.execCommand('copy')
      parentElement.removeChild(copyTextElement)
    })
  },
  destroyed () {
    this.$root.$off('copy-text')
  }
}
</script>

<style lang="scss">
  @import '@/styles/main.scss';
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    .web3modal-modal-lightbox {
      z-index: 100;
    }
  }
</style>
